import Search from '@/components/ui/molecules/search'
import SearchTerms from '@/components/ui/molecules/search-terms'
import { navigate } from '@/lib/client'

export default function FreeSearch({
  breadcrumbs,
  search,
  pathname,
  theme,
  placeholder = 'Pesquisar...',
}: {
  breadcrumbs: Array<{ name: string; href: string }>
  search?: string
  pathname: string
  theme?: string
  placeholder?: string
}) {
  const current = new URLSearchParams(search)
  const currentPath = pathname

  const selected = [
    {
      type: 'search',
      value: current.get('search'),
    },
  ]

  const handleSearch = (search: {
    type: string
    value: string
  }) => {
    if (search.value === '0') current.delete(search.type)
    else {
      if (search.type === 'free') current.set('search', search.value)
    }

    const parsed = current.toString()
    const query = parsed ? `?${parsed}` : ''

    navigate(`/${currentPath}${query}`)
  }

  return (
    <>
      <Search
        theme={theme}
        placeholder={placeholder}
        suggestions={[]}
        handleSearch={handleSearch}
      />

      <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0 lg:space-x-4 my-4">
        <div className="flex justify-center mb-4 md:mb-0">
          <SearchTerms
            theme="light"
            href={breadcrumbs[1]?.href}
            handleSearch={handleSearch}
            selected={selected?.filter((t) => t.value)}
          />
        </div>
      </div>
    </>
  )
}
